// Refactor 02/2026 — extrahiert aus AppointmentsPage.js.
// Pre-flight check: hat ein Kunde am Vortag, selben Tag oder Folgetag
// bereits einen Termin? Wenn ja, User per window.confirm warnen.
// Wird sowohl beim Buchen, Editieren als auch beim Drag&Drop verwendet.
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const runCustomerConflictCheck = async (
  customerId,
  startTimeIso,
  excludeAppointmentId = null,
  customers = []
) => {
  if (!customerId) return true;
  try {
    const resp = await axios.get(`${API}/appointments/customer-conflicts`, {
      params: {
        customer_id: customerId,
        start_time: startTimeIso,
        ...(excludeAppointmentId
          ? { exclude_appointment_id: excludeAppointmentId }
          : {}),
      },
    });
    if (!resp.data?.has_conflicts) return true;

    const customer = customers.find((c) => c.id === customerId);
    const customerName = customer
      ? `${customer.first_name} ${customer.last_name}`
      : 'Dieser Kunde';
    const lines = resp.data.conflicts.map((c) => {
      const when =
        c.offset_days === 0
          ? 'am selben Tag'
          : c.offset_days === -1
            ? 'am Vortag'
            : 'am Folgetag';
      return `• ${when} um ${c.local_time} (${c.service_name})`;
    });
    return window.confirm(
      `⚠️ ${customerName} hat bereits einen Termin:\n\n` +
        `${lines.join('\n')}\n\nTrotzdem fortfahren?`
    );
  } catch (err) {
    console.warn('Conflict preflight failed:', err);
    return true;
  }
};

export default runCustomerConflictCheck;
